// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2bC_3","text":"SelectPayment_text__3HhmK","title":"SelectPayment_title__1Xg_N","btn":"SelectPayment_btn__Iqa8U"};